import _ from "lodash";

require('../../bootstrap');

import Vue from 'vue';
import ComponentSet from "../../ComponentSet";
import utils from "../../Utils";
import Constants from "../../Constants";

import * as rules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import {extend, localize, setInteractionMode, ValidationObserver, ValidationProvider} from 'vee-validate';

en.messages.min = "Please enter 6~12 English letters or numbers.";
en.messages.confirmed = "The password does not match."

// -------------------------------------------------------
//                  VeeValidate 設定
// -------------------------------------------------------
localize('en', en);
setInteractionMode('eager');

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

const components = _.assign(ComponentSet, { ValidationProvider, ValidationObserver,} );

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data: { 
        username      : "",
        password      : "",
        token         : "",
        backend_token : "",
        returnUrl     : "",
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        let self = this;
        self.loadToken(self, 'login');
    },
    methods: {
        submitData(){
            
            let url  = Constants.serverRoot+`/normal/frontend/login`;
            let self = this;

            this.showLoading = true;
            
            this.returnUrl     = $("input[name='returnUrl']").val();
            
            _.set(this, 'contentData.post.username'     , this.username);
            _.set(this, 'contentData.post.password'     , this.password);
            _.set(this, 'contentData.post.token'        , this.token);
            _.set(this, 'contentData.post.keep'         , false);
            _.set(this, 'contentData.post.returnUrl'    , this.returnUrl);

            this.$http.post(url, _.get(self, 'contentData.post', null))
                .then(function (response){
                    let data = response.data.Value;
                    
                    console.log(data)
                    console.log(data.success)
                    if (data.success) {
                        console.log(1)
                        self.$refs.observer.reset();
                        window.location.href = data.value.url;
                    } else {
                        console.log(2)
                        self.showMessage({ config: {
                            msg: data.message
                        }});
                    }
                    self.showLoading = false;
                    self.loadToken(self, 'login');
                })
                .catch(function (error) {
                    self.showMessage({ config: {
                        msg: '請稍後再試。'
                    }});
                    self.showLoading = false;
                    self.loadToken(self, 'login');
                })
        }
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        }
    }, // end of computed
}).$mount('#app');